module.exports = __webpack_public_path__ + "img/1.93d85f3b.png";